import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { whatsappapi } from "../../Appjs/api.js";
import { create } from "@mui/material/styles/createTransitions.js";
import { ConstructionOutlined, Edit } from "@mui/icons-material";

export const whatsApi = createApi({
  reducerPath: "whatsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: whatsappapi,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("accessToken");
      if (token) headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  tagTypes: ["whatsApp"],
  endpoints: (builder) => ({
    // ✅ Get templates (customer_id will come from component)
    getTemplates: builder.query({
      query: ({ customer_id, template_id, template_name }) => ({
        url: `/templates/${customer_id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",
        },
        params: {
          name: template_name,
          template_id,
        },
      }),
      providesTags: ["whatsApp"],
    }),
    llmTemplates: builder.query({
      query: ({ waba_id, customer_id, base_name }) => ({
        url: `/llm_templates?waba_id=${waba_id}&customer_id=${customer_id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",
        },
        params: {
          name: base_name,
        },
      }),
      providesTags: ["whatsApp"],
    }),
    getPhoneNUmber: builder.query({
      query: (customer_id) => ({
        url: `/user-details/${customer_id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",
        },
      }),
      providesTags: ["whatsApp"],
    }),

    // ✅ Create Template API
    createTemplate: builder.mutation({
      query: (formData) => ({
        url: `/templates/`,
        method: "POST",
        body: formData,
        headers: {
          "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",
        },
      }),
      invalidatesTags: ["whatsApp"],
    }),


    createllmTemplate: builder.mutation({
      query: (formData) => ({
        url: `/llm_template/`,
        method: "POST",
        body: formData,
        headers: {
          "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",
        },
      }),
      invalidatesTags: ["whatsApp"],

    }),
    deleteLlmTemplate: builder.mutation({
      query: ({ customer_id, template_id }) => ({
        url: "/llm_template",
        method: "DELETE",
        params: { customer_id, template_id },
        headers: {
          "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",
        },
      }),
      invalidatesTags: ["whatsApp"],
    }),
    editTemplate: builder.mutation({
      query: ({ customer_id, template_id, formData }) => ({
        url: `/templates/${customer_id}/${template_id}`,
        method: "PUT",
        body: formData,
        headers: {
          "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",
        },
      }),
      invalidatesTags: ["whatsApp"],
    }),
    updateWhatsappTemplate: builder.mutation({
      query: ({ customer_id, template_id, body }) => ({
        url: `/templates/${customer_id}/${template_id}`,
        method: "PUT",
        body,
        headers: {
          "Content-Type": "application/json",
          "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",
        },
      }),
      invalidatesTags: ["whatsApp"],
    }),

    deleteTemplate: builder.mutation({
      query: ({ customer_id, name }) => ({
        url: `/${customer_id}/templates?name=${encodeURIComponent(name)}`,
        method: "DELETE",
        headers: {
          "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",
        },
      }),
      invalidatesTags: ["Templates"],
    }),
    sendMessage: builder.mutation({
      // Keep sendMessage as JSON-based API (payload) for small requests
      query: ({ payload, customer_id }) => ({
        url: `/messages/${customer_id}/send`,
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
          "Content-Type": "application/json",
          "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",
        },
      }),
      invalidatesTags: ["whatsApp"], // Add this to invalidate cache
    }),

    // Batch/message upload endpoint: accept FormData (file uploads)
    sendMessageBatch: builder.mutation({
      // Expect an object { formData, customer_id } where formData is FormData
      query: ({ formData }) => ({
        url: `/messages`,
        method: "POST",

        body: formData,
        headers: {
          "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",
        },
      }),
      invalidatesTags: ["whatsApp"],
    }),
    whatsappReport: builder.query({
      query: ({ customer_id, page = 1, limit = 10, start_date, end_date }) => ({
        url: `/messages/${customer_id}`,
        method: "GET",
        params: {
          page,
          limit,
          start_date,
          end_date,
        },
        headers: {
          "Content-Type": "application/json",
          "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",
        },
      }),
      providesTags: ["whatsApp"],
    }),

    whatsappchatlist: builder.query({
      query: ({ customer_id, page = 1, limit = 10 } = {}) => ({
        url: `/messages/${customer_id}/campaigns`,
        method: "GET",
        params: { page, limit },
        headers: {
          "Content-Type": "application/json",
          "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",
        },
      }),
      providesTags: ["whatsApp"],
    }),
    whatappchatmessages: builder.query({
      query: ({ customer_id, campaign_id }) => ({
        url: `/messages/${customer_id}/${campaign_id}/replies?page=1&flat=false&include_text=true`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",
        },
      }),
      providesTags: ["whatsApp"],
    }),
    getWhatsappChatAgents: builder.query({
      query: (customerId) => ({
        url: `/customers/${customerId}/chat-agents`,
        method: "GET",
        headers: {
          accept: "application/json",
          "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",
        },
      }),
      transformResponse: (response) => response.agents || [],

      providesTags: ["whatsApp"],
    }),

    createWhatsappChatAgent: builder.mutation({
      query: ({ customer_id, ...body }) => ({
        url: `/customers/${customer_id}/chat-agents`,
        method: "POST",
        body,
        headers: {
          "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: ["whatsApp"],
    }),
    deleteWhatsappChatAgent: builder.mutation({
      query: ({ customer_id, agent_id }) => ({
        url: `/customers/${customer_id}/chat-agents/${agent_id}`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",
        },
      }),
      invalidatesTags: ["whatsApp"],
    }),
    assignAgentToChat: builder.mutation({
      query: ({ customer_id, message_id, agent_id }) => ({
        url: `/customers/${customer_id}/chat-agents/${agent_id}/assign-message/${message_id}`,
        method: "POST",
        body: { agent_id },
        headers: {
          "Content-Type": "application/json",
          "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",
        },
      }),
      invalidatesTags: ["whatsApp"],
    }),
    getWhatsappFlowReport: builder.query({
      query: ({ customer_id, campaignflow_id }) => ({
        url: `/messages/${customer_id}/flow/${campaignflow_id}/status`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",
        },
      }),
      providesTags: ["whatsApp"],
    }),
    getwhatsappFlowreportCount: builder.query({
      query: ({ customer_id, status, campaign_flow_id }) => ({
        url: `/messages/${customer_id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",
        },
        params: {
          status,
          campaign_flow_id,
        },
      }),
      providesTags: ["whatsApp"],
    }),
    updateWhatsappConfig: builder.mutation({
      query: (payload) => ({
        url: "/register",
        method: "PATCH",
        body: payload,
        headers: {
          "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",
        },
      }),
      invalidatesTags: ["WhatsappConfig"],
    }),
    getwhatsappconsilidatedreport: builder.query({
      query: ({ customer_id, page = 1, limit = 50, start_date, end_date }) => ({
        url: `/admin/messages`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",
        },
        params: {
          page,
          limit,
          customer_id,
          start_date,
          end_date,
        },
      }),
      providesTags: ["whatsApp"],
    }),
    getwhatsappscheduledcampaigns: builder.query({
      query: ({
        customer_id,
        status,
        date,
        page = 1,
        limit = 25,
        start_date,
        end_date,
      }) => ({
        url: `/messages/${customer_id}/scheduled-campaigns`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",
        },
        params: {
          page,
          limit,
          status,
          date,
          start_date,
          end_date,
        },
      }),
      providesTags: ["whatsApp"],
    }),
    updateschedulecampaign: builder.mutation({
      query: ({ customer_id, campaign_id, ...body }) => ({
        url: `/messages/${customer_id}/scheduled-campaigns/${campaign_id}`,
        method: "PUT",
        body,
        headers: {
          "Content-Type": "application/json",
          "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",

        },
      }),
      invalidatesTags: ["whatsApp"],
    }),
    testwhatsappmsg: builder.mutation({
      query: ({ customer_id, formData }) => ({
        url: `/messages/${customer_id}/send-multiple`,
        method: "POST",
        body: formData,
        headers: {
          "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",
        },
      }),
      invalidatesTags: ["whatsApp"],
    }),
    ConstructionOutlined: builder.query({
      query: ({ customerId, start_date, end_date }) => ({
        url: `/billing/${customerId}/consolidated`,
        method: "GET",
        headers: {
          "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",
        },
        params: {
          start_date: start_date,
          end_date: end_date,
        },
      }),
      providesTags: ["Billing"],
    }),
    whatsappchatbotcreate: builder.mutation({
      query: ({ phone_number_id, ...body }) => ({
        url: `/phone-numbers/${phone_number_id}/workflows`,
        method: "POST",
        body,
        headers: {
          "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: ["whatsApp"],
    }),
    getwhatsappchatflowlist: builder.query({
      query: ({ phone_number_id, customer_id }) => ({
        url: `/phone-numbers/${phone_number_id}/workflows/list?customer_id=${customer_id}`,
        headers: {
          "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }),
      providesTags: ["whatsApp"],
    }),
    selectwhatsappchatflow: builder.query({
      query: ({ phone_number_id, customer_id, workflow_id }) => ({
        url: `/phone-numbers/${phone_number_id}/workflows?customer_id=${customer_id}&workflow_id=${workflow_id}`,
        headers: {
          "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }),
      providesTags: ["whatsApp"],
    }),
    whatsdetailappReport: builder.query({
      query: ({
        customerId,
        campaign_id,
        messages_offset = 0,
        messages_limit = 25,
        status,
        page = 1,
        limit = 25,
        direction = "outbound",
        include_replies = false,
      }) => {
        const params = {
          campaign_id,
          messages_offset,
          messages_limit,
          page,
          limit,
          direction,
          include_replies,
        };
        // "all" / "sent" are the default view — only send status when it
        // actually narrows the result set server-side.
        if (status && status !== "all" && status !== "sent") {
          params.status = status;
        }

        return {
          url: `/messages/${customerId}`,
          method: "GET",
          headers: {
            "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",
          },
          params,
        };
      },
      providesTags: ["whatsApp"],
    }),
    getwhatsappdlrurl: builder.query({
      query: (customer_id) => ({
        url: `/customer-webhook?customer_id=${customer_id}`,
        headers: {
          "Content-Type": "application/json",
          "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",
        },
      })
    }),
    patchwhatsappdlrurl: builder.mutation({
      query: (payload) => ({
        url: `/customer-webhook`,
        method: "PATCH",
        body: payload,
        headers: {
          "Content-Type": "application/json",
          "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",
        },
      }),
    }),
    getWhatsappreplies: builder.query({
      query: ({ customer_id, campaign_id }) => ({
        url: `/messages/${customer_id}/${campaign_id}/replies`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",
        },
      })
    }),
    getapireport: builder.query({
      query: ({ customer_id, start_date, end_date, page, limit }) => ({
        url: `/messages/${customer_id}?source=send-immediate&start_date=${start_date}&end_date=${end_date}&page=${page}&limit=${limit}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",
        },
      })
    }),
    getapisenttemplate: builder.query({
      query: ({ customer_id, template_name }) => ({
        url: `/templates/${customer_id}?name=${template_name}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",
        },
      })
    }),
    getllmsepratetemplate: builder.query({
      query: ({ waba_id, customer_id, template_name }) => ({
        url: `/llm_templates?waba_id=${waba_id}&customer_id=${customer_id}&base_name=${template_name}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",
        },
      })
    }),
    getDownloadcenterlist: builder.query({
      query: ({ customer_id, start_date, end_date }) => ({
        url: `/messages/${customer_id}/dlr-reports/requests?start_date=${start_date}&end_date=${end_date}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",
        },
      })
    }),
    giveDownloadrequestforreport: builder.query({
      query: ({ customer_id, start_date, end_date, report_type, report_type_id, phone_number, waba_id }) => ({
        url: `/messages/${customer_id}/dlr-reports`,
        method: "GET",
        params: {
          report_type,
          report_type_id,
          start_date,
          end_date,
          ...(phone_number && { phone_number }),
          ...(waba_id && { waba_id }),
        },
        headers: {
          "Content-Type": "application/json",
          "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",
        },
      })
    }),
    downloadreport: builder.query({
      query: ({ customer_id, request_id }) => ({
        url: `/messages/${customer_id}/dlr-reports/${request_id}/download`,
        method: "GET",
        headers: {
          "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",
        },
        responseHandler: (response) => response.text(), // CSV comes back as plain text
      }),
      keepUnusedDataFor: 0, // don't keep big CSVs in the cache
    }),

    getWhatsappCampaignListAdmin: builder.query({
      query: ({
        startdate,
        enddate,
        page = 1,
        limit = 25,
        customer_name,
        customer_id,
        status,
      }) => {
        const today = new Date().toISOString().split("T")[0];
        const fromDate = startdate || today;
        const toDate = enddate || today;

        return {
          url: "/admin/messages",
          method: "GET",
          headers: {
            "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",
          },
          params: {
            start_date: fromDate,
            end_date: toDate,
            page,
            limit,
            ...(customer_id ? { customer_id } : {}),
            ...(customer_name ? { customer_name } : {}),
            ...(status ? { status } : {}),
          },
        };
      },
      providesTags: ["WhatsappConfig"],
    }),
  getwhatsappcampaignpreview: builder.mutation({
    query: ({ customer_id, formData }) => ({
      url: `/messages/${customer_id}/stats`,
      method: "POST",
      body: formData,
      headers: {
        "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",
      },
    }),
  }),
  deletedownloadcenterfile: builder.mutation({
    query: ({ customer_id, dlr_request_id }) => ({
      url: `/messages/${customer_id}/dlr-reports/${dlr_request_id}`,
      method: "DELETE",
      headers: {
        "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",
      },
    }),
  }),
})
});



export const {
  useAssignAgentToChatMutation,
  useCreateWhatsappChatAgentMutation,
  useGetWhatsappChatAgentsQuery,
  useGetTemplatesQuery,
  useCreateTemplateMutation,
  useDeleteTemplateMutation,
  useGetPhoneNUmberQuery,
  useLazyGetPhoneNUmberQuery,
  useSendMessageMutation,
  useSendMessageBatchMutation,
  useWhatsappReportQuery,
  useWhatsappchatlistQuery,
  useWhatappchatmessagesQuery,
  useDeleteWhatsappChatAgentMutation,
  useGetWhatsappFlowReportQuery,
  useGetwhatsappFlowreportCountQuery,
  useLazyGetwhatsappFlowreportCountQuery,
  useUpdateWhatsappConfigMutation,
  useGetwhatsappconsilidatedreportQuery,
  useEditTemplateMutation,
  useLazyGetwhatsappscheduledcampaignsQuery,
  useUpdateschedulecampaignMutation,
  useTestwhatsappmsgMutation,
  useConstructionOutlinedQuery,
  useWhatsappchatbotcreateMutation,
  useGetwhatsappchatflowlistQuery,
  useSelectwhatsappchatflowQuery,
  useWhatsdetailappReportQuery,
  useLazyWhatsdetailappReportQuery,
  useGetwhatsappdlrurlQuery,
  usePatchwhatsappdlrurlMutation,
  useGetWhatsapprepliesQuery,
  useGetapireportQuery,
  useGetapisenttemplateQuery,
  useCreatellmTemplateMutation,
  useDeleteLlmTemplateMutation,
  useLlmTemplatesQuery,
  useLazyLlmTemplatesQuery,
  useGetllmsepratetemplateQuery,
  useGetDownloadcenterlistQuery,
  useGiveDownloadrequestforreportQuery,
  useLazyGiveDownloadrequestforreportQuery,
  useLazyDownloadreportQuery,
  useGetWhatsappCampaignListAdminQuery,
  useGetwhatsappcampaignpreviewMutation,
  useUpdateWhatsappTemplateMutation,
  useLazySelectwhatsappchatflowQuery,
  useDeletedownloadcenterfileMutation,
} = whatsApi;
